import { Payee } from '@root/api/ump-catalog-manager'
import { SearchPayee } from '../model/tsp.types'
import { omitUndefined } from './omitUndefined'

const pickSearchPayeeFields = (payee: Payee): SearchPayee =>
  omitUndefined({
    providerName: payee.providerName,
    icon: payee.icon,
    features: omitUndefined({
      tsp_url: payee.features?.tsp_url as string | undefined,
      tsp_picture_web: payee.features?.tsp_picture_web as string | undefined,
      platform_type: payee.features?.platform_type as string | undefined,
    }),
  })

export const omitUnusedSearchPayeeFields = (payees: Payee[]): SearchPayee[] => payees.map(pickSearchPayeeFields)
